import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';

import { AnalyticsService } from '../services/analytics.service';
import { SecurityService } from '../services/SecurityService';

@Injectable()
export class AnalyticsGuard implements CanActivate {
    constructor(
        private oidcSecurityService: OidcSecurityService,
        private securityService: SecurityService,
        private analyticsService: AnalyticsService,
    ) {}

    async canActivate(): Promise<boolean> {
        const authConfigId = this.securityService.getAuthConfigId();
        const encodedRedirectionUrl = await firstValueFrom(this.oidcSecurityService.getState(authConfigId));

        if (encodedRedirectionUrl) {
            const url = atob(encodedRedirectionUrl);
            this.triggerAnalyticsEvent(url);
        }

        return true;
    }

    private triggerAnalyticsEvent(urlStr: string) {
        const url = new URL(urlStr);
        const isInterventionAcceptedUrl = /^\/query\/intervention\/[^/]+$/.test(url.pathname);
        const isLinkRequestAcceptedUrl = /^\/enduser\/link-request\/[^/]+\/accept$/.test(url.pathname);

        if (isInterventionAcceptedUrl) {
            this.analyticsService.interventionLinkClicked();
        }

        if (isLinkRequestAcceptedUrl) {
            this.analyticsService.linkRequestAcceptLinkClicked();
        }
    }
}
